import { render } from "./PresentationPage.vue?vue&type=template&id=6651d664&scoped=true"
import script from "./PresentationPage.vue?vue&type=script&lang=js"
export * from "./PresentationPage.vue?vue&type=script&lang=js"

import "./PresentationPage.vue?vue&type=style&index=0&id=6651d664&scoped=true&lang=css"

import exportComponent from "/home/test/Documents/GitHub/LpMooveTrainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6651d664"]])

export default __exports__